export default {
    api:{
        endpoint: process.env.NODE_ENV === "development" ? "http://localhost:8080" : "https://www.haoping.fun/api"
    },
    isProd: process.env.NODE_ENV !== "development"
}
